// extracted by mini-css-extract-plugin
export default {"category_container":"CartoonCategories_category_container__wIFr6","gap_20":"CartoonCategories_gap_20__UVBGh"};